import React from "react";
import {Button, Row, Col, FormControl, ButtonGroup} from "react-bootstrap";
import Component from "../../components/AscComponent";
import { buildCallTextDownloadFilenameFromPlaybackState, normalizeExternalNumber, hasRecAceContract } from "../../components/AscUtils";
import { CALL_TEXT_DOWNLOAD } from "../../config/constants";
import CommonTable from "../../containers/Elements/Table/CommonTable";
import RecordPlaybackModal from "./RecordPlaybackModal";
import RecordVocAnalysisModal from "./RecordVocAnalysisModal";
import moment from "moment";
import {faDownload, faPlay, faMinus, faTextWidth, faStickyNote, faSpinner} from "@fortawesome/free-solid-svg-icons";
import DatePicker, { registerLocale} from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import * as GlobalConst from "../../components/AscConstants";
import ja from 'date-fns/locale/ja';
import ReactLoading from 'react-loading';
import ButtonSpeechBubble from "../Elements/AscElements/SetButtonWithSpeechBubble";
import Creatable from 'react-select/creatable';
import Select from 'react-select';
import { addYears } from 'date-fns';
registerLocale('ja', ja);


// デフォルトカテゴリ色定数
const DEFAULT_CATEGORY_BG_COLOR = '#ED7C47';
const DEFAULT_CATEGORY_FONT_COLOR = '#ffffff';
// 【#587】表の高さを画面の残りから求めるときの値
const RECORD_TABLE_BOTTOM_HEIGHT = 80; // CommonTable の tableBottomHeight（枠の max-height = tableHeight - この値）
const RECORD_TABLE_MIN_HEIGHT = 300;   // これより低い画面では画面全体のスクロールを許す
const RECORD_PAGINATION_HEIGHT = 60;   // ページ送りの描画前に使う仮の高さ

export default class Record extends Component {

    constructor(props) {
        super(props);
        this.state = {
            // table item
            columns: this.getColumnsData(),
            data: [],
            pages: null,
            pageSize: 20,
            loading: false,
            hidden_filtered: [
                {
                    id: "user_id",
                    value: this.props.userInfo.user_id
                }
            ],
            filtered: [
                {
                    id: "user_id",
                    value: this.props.userInfo.user_id
                }
            ],
            sorted: [{id: "answer_datetime", desc: true}],
            audio2text_usage_month: 0,

            // modal item
            show: false,
            modalType: null,
            companySelect: [],
            selectedData: [],
            blocking: false,
            search_flag: true,
            search_message: "",
            loadingDisplayFlag: false,
            csvDownloading: false,

            // VoCカテゴリ関連
            vocCategoryOptions: [],
            selectedVocCategories: [],

            // 検索フィールド
            keywords: [],
            categoriesSearch: [],
            categoryOptions: [],  // 通話分類マスターデータ

            // Issue #289: Record search - 外線番号プルダウン用
            externalNumberOptions: [],          // プルダウン候補リスト [{value, label, name}]
            selectedExternalNumbers: [],        // 選択中の外線番号 [{value, label, name}]
            externalNumberMap: {}              // 外線番号→名称マップ（一覧/CSV表示用）
        };


        this.getAudio2TextUsageMonth();
        this.getCategoryMasterData();
        this.categoryOptionsMap = new Map();
        // テキスト化再実行のポーリングタイマー（ht60_id => intervalId）
        this.audio2TextPollTimers = {};
        this.table = React.createRef();
        // 【#587】表の高さを検索エリアの実寸から決めるための参照
        this.tableAreaRef = React.createRef();
        this.searchPanelRef = React.createRef();
        this.hourShowList = this.getSelectOption('hour_show_list', this.props.langText.SelectOption);
        this.minuteShowList = this.getSelectOption('minute_show_list', this.props.langText.SelectOption);
    }

    componentWillUnmount() {
        // ポーリングタイマーのクリーンアップ（メモリリーク・不要なAPI呼び出し防止）
        Object.values(this.audio2TextPollTimers).forEach(timerId => clearInterval(timerId));
        this.audio2TextPollTimers = {};
        this.unmounted = true;
        if (this.tableResizeObserver) {
            this.tableResizeObserver.disconnect();
        }
        if (this.tableHeightFrame) {
            window.cancelAnimationFrame(this.tableHeightFrame);
        }
        window.removeEventListener("resize", this.updateTableHeight);
    }

    /**
     * 【#587】表の高さを、画面の残り（検索エリアの下からページ送りまで）に合わせる。
     * 従来は App.js の固定値（table_size_tune）から求めており、検索条件の行が増えると
     * 画面全体にスクロールが出ていた。検索エリアの実寸を測って決める。
     * スマホ幅（App.js が画面全体のスクロールを前提にしている）では従来どおり。
     */
    updateTableHeight = () => {
        // ResizeObserver とリサイズが続けて来ても、1 フレームに 1 回だけ測る
        if (this.tableHeightFrame) {
            return;
        }
        this.tableHeightFrame = window.requestAnimationFrame(() => {
            this.tableHeightFrame = null;
            if (!this.unmounted) {
                this.measureTableHeight();
            }
        });
    }

    measureTableHeight = () => {
        const routesApp = document.getElementById("routes-app");
        const tableArea = this.tableAreaRef.current;
        if (!routesApp || !tableArea || window.innerWidth < 768) {
            if (this.state.tableHeight) {
                this.setState({tableHeight: null});
            }
            return;
        }
        const appStyle = window.getComputedStyle(routesApp);
        const paddingBottom = parseFloat(appStyle.paddingBottom) || 0;
        const tableTop = tableArea.getBoundingClientRect().top
            - routesApp.getBoundingClientRect().top + routesApp.scrollTop;
        const pagination = tableArea.querySelector(".pagination");
        let paginationHeight = RECORD_PAGINATION_HEIGHT;
        if (pagination) {
            const pagStyle = window.getComputedStyle(pagination);
            paginationHeight = pagination.offsetHeight
                + (parseFloat(pagStyle.marginTop) || 0) + (parseFloat(pagStyle.marginBottom) || 0);
        }
        const available = routesApp.clientHeight - paddingBottom - tableTop - paginationHeight;
        const tableHeight = Math.max(Math.floor(available) + RECORD_TABLE_BOTTOM_HEIGHT, RECORD_TABLE_MIN_HEIGHT);
        // 1px 程度の揺れ（スクロールバーの出入り等）で測り直しが続かないよう、2px 未満の差は無視する
        if (Math.abs(tableHeight - (this.state.tableHeight || 0)) >= 2) {
            this.setState({tableHeight});
        }
    }

    /**
     * 一覧の特定行のテキスト化ステータスを更新（楽観的更新・ポーリング反映用）
     * 関数型 setState で最新の state.data を基に更新し、stale state を回避する。
     */
    setRowAudio2TextStatus = (ht60_id, status) => {
        this.setState(prevState => ({
            data: prevState.data.map(row =>
                row.id === ht60_id
                    ? {...row, ht87_voice_log_to_text: {...(row.ht87_voice_log_to_text || {}), status}}
                    : row
            )
        }));
    }

    /**
     * テキスト化再実行後のポーリング開始。
     * 対象行のht87ステータスを5秒間隔で確認し、終了状態(REQUEST_ACCEPTED/WORKING以外)で
     * 一覧表示を自動更新する。最大20分でタイムアウト（ハング判定閾値と同等）。
     * 一時的な通信エラーでは即停止せず、連続エラーが上限に達した場合のみ停止する。
     */
    startAudio2TextPolling = (ht60_id) => {
        if (this.audio2TextPollTimers[ht60_id]) {
            clearInterval(this.audio2TextPollTimers[ht60_id]);
        }
        const startedAt = Date.now();
        const MAX_POLL_MS = 20 * 60 * 1000;
        const POLL_INTERVAL_MS = 5000;
        const MAX_CONSECUTIVE_ERRORS = 3;
        let consecutiveErrors = 0;

        const stopPolling = () => {
            clearInterval(this.audio2TextPollTimers[ht60_id]);
            delete this.audio2TextPollTimers[ht60_id];
        };

        this.audio2TextPollTimers[ht60_id] = setInterval(async () => {
            if (Date.now() - startedAt > MAX_POLL_MS) {
                stopPolling();
                return;
            }
            try {
                const res = await this.ascAxios(
                    'post', `${this.reactContainerPath}/getVoiceLogToTextByHt60id`, {ht60_id}
                );
                const ht87 = res && res.data && res.data.ht87_voice_log_to_text;
                const status = ht87 && ht87.status;
                consecutiveErrors = 0; // 成功したら連続エラーカウンタをリセット
                // status が null/undefined/空（論理削除後・新規INSERT前でht87未生成）や
                // REQUEST_ACCEPTED/WORKING は処理中とみなしてポーリングを継続する。
                // それ以外（CONVERSION_COMPLETE や失敗系）になったら終了。
                const isProcessing = !status || status === "REQUEST_ACCEPTED" || status === "WORKING";
                if (!isProcessing) {
                    this.setRowAudio2TextStatus(ht60_id, status);
                    stopPolling();
                }
            } catch (err) {
                consecutiveErrors++;
                console.error(`audio2text polling error (${consecutiveErrors}/${MAX_CONSECUTIVE_ERRORS}):`, err);
                // 一時的なエラー（タイムアウト・5xx等）では継続し、連続上限到達時のみ停止
                if (consecutiveErrors >= MAX_CONSECUTIVE_ERRORS) {
                    stopPolling();
                }
            }
        }, POLL_INTERVAL_MS);
    }

    /**
     * テキスト化再実行の起点（モーダルから呼ばれる）。
     * 対象行を楽観的に処理中表示にし、ポーリングを開始する。
     */
    onAudio2TextRetryStart = (ht60_id) => {
        this.setRowAudio2TextStatus(ht60_id, "REQUEST_ACCEPTED");
        this.startAudio2TextPolling(ht60_id);
    }

    componentDidMount() {
        // Issue #289: Record search - 初期ユーザーの外線番号候補を取得
        // constructor ではなく componentDidMount で実行することで React のライフサイクル推奨に従う
        this.getExternalNumberOptions(this.props.userInfo.user_id);
        // 【#587】検索エリアの高さ（条件の折り返し・権限による項目の増減）と画面サイズの変化に追随する
        window.addEventListener("resize", this.updateTableHeight);
        if (typeof ResizeObserver !== "undefined") {
            this.tableResizeObserver = new ResizeObserver(() => this.updateTableHeight());
            if (this.searchPanelRef.current) {
                this.tableResizeObserver.observe(this.searchPanelRef.current);
            }
            // App.js が画面サイズに合わせて routes-app の高さを変えた後に測り直す
            const routesApp = document.getElementById("routes-app");
            if (routesApp) {
                this.tableResizeObserver.observe(routesApp);
            }
        }
        this.updateTableHeight();
    }

    /**
     * 顧客名取得メソッド(共通化)
     * RecACEplusアプリの分析結果を優先し、次に電話帳の顧客名を使用
     */
    getCustomerName(rowData) {
        let customerName = "";

        // RecACEplusアプリで分析された顧客名を優先
        if (rowData.ht88_voice_log_to_analyze && rowData.ht88_voice_log_to_analyze.customer_name) {
            customerName = rowData.ht88_voice_log_to_analyze.customer_name;
        }
        // 次に電話帳の顧客名を使用
        else if (rowData.hm01_customer_info && rowData.hm01_customer_info.name) {
            customerName = rowData.hm01_customer_info.name;
        }

        // null または "null" 文字列の場合は空白を返す
        if (!customerName || customerName === "null") {
            return "";
        }

        return customerName;
    }

    /**
     * 一覧表作成
     */
    getColumnsData() {

        let returnArray;

        if (window.innerWidth <= 768) {
            returnArray = [ 
                {
                    Header: this.props.langText.Body.NumInfo,
                    accessor: "dest_tel_number",
                    width: this.props.boardWidth.small,
                    Cell: data => {
                        let customerName = "";
                        const telNumber = data.row.original.dest_tel_number || this.props.langText.Body.AnonymousNumber;
                        let inout_type = "";
                        let rowData = [];

                        if (data.row.original.inout_type === "in") {
                            inout_type = this.props.langText.Body.IncomingIcon
                        } else if (data.row.original.inout_type === "out") {
                            inout_type = this.props.langText.Body.OutgoingIcon
                        }

                        // 共通メソッドで顧客名を取得
                        customerName = this.getCustomerName(data.row.original);

                        rowData.push(<div>{data.row.original.external_number}</div>);
                        rowData.push(<div>{inout_type}</div>);
                        if (customerName) {
                            rowData.push(<div title={customerName}>{customerName}</div>);
                        }
                        rowData.push(<div title={telNumber}>{telNumber}</div>);
                        return rowData;
                    },
                }, {
                    Header: this.props.langText.Body.CallInfo,
                    accessor: "answer_datetime",
                    width: this.props.boardWidth.small,
                    Cell: data =>(
                        <>
                            <div className = "call_time">
                                {moment(data.row.original.answer_datetime).utc().add(9, "h").format("YYYY/MM/DD")}
                            </div>
                            <div className = "call_time">
                                {moment(data.row.original.answer_datetime).utc().add(9, "h").format("HH:mm:ss")}
                            </div>
                            <div className = "billsec">
                                {this.getFormatSec(data.row.original.billsec)}
                            </div>
                        </>

                    )
                }
            ];
        } else {
            returnArray = [
                {
                    Header: this.props.langText.Body.CallCategory,
                    accessor: "categories",
                    // Issue #349: 列表示はサブユーザートグル（RecAceApp）ではなく契約有無で判定
                    show: hasRecAceContract(this.props.userInfo.options),
                    // 【#591】中身はバッジ 1〜2 個のため最大幅は不要。余った幅は外線番号へ回す
                    width: this.props.boardWidth.medium,
                    Cell: data => {
                        if (data.row.original.ht88_voice_log_to_analyze) {
                            let categories = data.row.original.ht88_voice_log_to_analyze.categories;
                            return (
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '3px 5px', justifyContent: 'center' }}>
                                    {categories.map((row, idx) => (
                                        <span
                                            key={row.awt065_id || idx}
                                            style={{
                                                backgroundColor: row.rgb,
                                                padding: '2px 4px',
                                                borderRadius: '4px',
                                                color: row.font_rgb,
                                            }}
                                        >
                                            {row.name}
                                        </span>
                                    ))}
                                </div>
                            );
                        } else {
                            return "";
                        }
                    }
                }, {
                    Header: this.props.langText.Body.ExternalNumber,
                    accessor: "external_number",
                    // 【#591】名称を併記するため、番号だけの列より広く取る
                    width: this.props.boardWidth.xlarge,
                    // Issue #289: Record search - 外線番号に名称を併記
                    // 【#591】番号を 1 行目、名称を 2 行目に分けて表示する。括弧付きで 1 行に並べると
                    // 名称の長さ次第で番号の途中から折り返し、行の高さも揃わなかった。
                    Cell: data => {
                        const num = data.row.original.external_number || '';
                        const name = this.state.externalNumberMap[normalizeExternalNumber(num)];
                        if (name) {
                            return (
                                <div className="record-external-number" title={`${num} (${name})`}>
                                    <div className="record-external-number-value">{num}</div>
                                    <div className="record-external-number-name">{name}</div>
                                </div>
                            );
                        }
                        return num;
                    },
                }, {
                    Header: this.props.langText.Body.ExtensionNumber,
                    accessor: "extension_number",
                    show: !!(this.props.userInfo.options && this.props.userInfo.options.aspire),
                    // 【#591】内線番号は数桁のため狭くする
                    width: this.props.boardWidth.xsmall,
                    Cell: data => data.row.original.extension_number || "-",
                }, {
                    Header: this.props.langText.Body.CustomerName,
                    accessor: "customer_name",
                    show: hasRecAceContract(this.props.userInfo.options),
                    width: this.props.boardWidth.CallNumber,
                    Cell: data => {
                        // 共通メソッドで顧客名を取得
                        const customerName = this.getCustomerName(data.row.original);
                        return customerName ? <span title={customerName}>{customerName}</span> : "";
                    },
                }, {
                    Header: this.props.langText.Body.DestTelNumber,
                    accessor: "dest_tel_number",
                    width: this.props.boardWidth.CallNumber,
                    Cell: data => {
                        return data.row.original.dest_tel_number || this.props.langText.Body.AnonymousNumber;
                    },
                }, {
                    Header: this.props.langText.Body.InOutType,
                    accessor: "inout_type",
                    // 【#591】「着信」「発信」の 2 文字だけ
                    width: this.props.boardWidth.xxsmall,
                    Cell: data => {
                        if (data.row.original.inout_type === "in") {
                            return this.props.langText.Body.Incoming
                        } else if (data.row.original.inout_type === "out") {
                            return this.props.langText.Body.Outgoing
                        } else {
                            return "";
                        }
                    }
                }, {
                    Header: this.props.langText.Body.CallDate,
                    accessor: "answer_datetime",
                    // 【#591】YYYY/MM/DD HH:mm:ss の 19 文字固定
                    width: this.props.boardWidth.large,
                    Cell: data => moment(data.row.original.answer_datetime).utc().add(9, "h").format("YYYY/MM/DD HH:mm:ss"),
                }, {
                    Header: this.props.langText.Body.BillSec,
                    accessor: "billsec",
                    // 【#591】HH:mm:ss の 8 文字固定
                    width: this.props.boardWidth.small,
                    Cell: data => {
                        return this.getFormatSec(data.row.original.billsec);
                    }
                }, {
                    Header: this.props.langText.Body.CallOverview,
                    accessor: "analysis_data_overview",
                    show: hasRecAceContract(this.props.userInfo.options),
                    width: this.props.boardWidth.xlarge,
                    Cell: data => {
                        if (data.row.original.ht88_voice_log_to_analyze 
                            && data.row.original.ht88_voice_log_to_analyze.analysis_data_overview) {
                            let overview = data.row.original.ht88_voice_log_to_analyze.analysis_data_overview;
                            const isTruncated = overview.length >= this.props.charaLimit.Call_Overview_Display;
                            const displayText = isTruncated 
                                ? overview.substring(0, this.props.charaLimit.Call_Overview_Display) + "…"
                                : overview;
                            
                            return (
                                <div title={isTruncated ? overview : ""} style={{whiteSpace: "pre-line"}}>
                                    {displayText}
                                </div>
                            );
                        } else {
                            return "";
                        }
                    }
                }
            ];
        }

        returnArray.push({
            Header: this.props.langText.Body.Control,
            accessor: "id",
            width: this.props.boardWidth.Control,
            Cell: data => {
                let rowData = [];
                if (data.row.original.s3_object_key) {
                    if (this.props.currentPermission.playback) {
                        rowData.push(
                            <ButtonSpeechBubble
                                key={data.row.original.s3_object_key + "_playback"}
                                size="sm"
                                onClick={this.modalShow("playback", data)}
                                className = "control-button"
                                DisplayIcon={faPlay}
                                speechBubble={[
                                    <div key={data.row.original.s3_object_key + "PlayBack"}>
                                        {this.props.langText.Body.PlayBack}
                                    </div>
                                ]}
                            />
                        );
                    }
                    if (this.props.currentPermission.download) {
                        rowData.push(
                            <ButtonSpeechBubble
                                key={data.row.original.s3_object_key + "_download"}
                                size="sm"
                                onClick={this.modalShow("download", data)}
                                className={"control-button"}
                                DisplayIcon={faDownload}
                                speechBubble={[
                                    <div key={data.row.original.s3_object_key + "_download_bubble"}>
                                        {this.props.langText.Body.AudioFileDownload}
                                    </div>
                                ]}
                            />
                        );
                    }

                    if ((!this.props.userInfo.options || (this.props.userInfo.options && !this.props.userInfo.options.audio2text))
                        && !this.props.userInfo.sub_user_id
                        && data.row.original.ht87_voice_log_to_text) {
                        let message;
                        let audio2textIcon = faTextWidth;
                        let audio2textSpin = false;
                        let audio2textClassName = "control-button-disabled";
                        switch (data.row.original.ht87_voice_log_to_text.status) {
                            case "CONVERSION_COMPLETE":
                                message = this.props.langText.Body.audio2textComplete;
                                break;
                            case "WORKING":
                            case "REQUEST_ACCEPTED":
                                // 処理中はスピナーを回転表示し、一目で処理中と分かるようにする
                                message = this.props.langText.Body.audio2textWorking;
                                audio2textIcon = faSpinner;
                                audio2textSpin = true;
                                audio2textClassName = "control-button-processing";
                                break;
                            default:
                                message = this.props.langText.Body.audio2textFailed;
                                break
                        }
                        rowData.push(
                            <ButtonSpeechBubble
                                key = {data.row.original.id + "_audio2text"}
                                size="sm"
                                className={audio2textClassName}
                                DisplayIcon={audio2textIcon}
                                spin={audio2textSpin}
                                speechBubble={message}
                            />
                        );
                    } else if ((!this.props.userInfo.options || (this.props.userInfo.options && !this.props.userInfo.options.audio2text))
                               && !this.props.userInfo.sub_user_id) {
                        rowData.push(
                            <ButtonSpeechBubble
                                key = {data.row.original.id + "_audio2text"}
                                size="sm"
                                className={"control-button"}
                                DisplayIcon={faTextWidth}
                                onClick={async () => {
                                    const ht60_id = data.row.original.id;
                                    try {
                                        await this.ascAxios(
                                            'post',
                                            `${this.reactContainerPath}/exeAudio2TextByHt60Id`,
                                            {id: ht60_id}
                                        );
                                        // 再実行と同じく処理中表示＋ポーリングで完了を自動反映
                                        this.onAudio2TextRetryStart(ht60_id);
                                    } catch (err) {
                                        console.error(err);
                                        this.showErrorObjectMessage(err);
                                    }
                                }}
                                speechBubble={[
                                    <div>{this.props.langText.Body.audio2text}</div>
                                ]}
                            />
                        );
                    }

                    // メモアイコン追加（メモが存在する場合のみ表示）
                    if (data.row.original.memo && data.row.original.memo.trim() !== '') {
                        rowData.push(
                            <ButtonSpeechBubble
                                key={data.row.original.id + "_memo"}
                                size="sm"
                                className="control-button-disabled"
                                DisplayIcon={faStickyNote}
                                speechBubble={[
                                    <div
                                        key={data.row.original.id + "_memo_bubble"}
                                        style={{
                                            maxWidth: '200px',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap'
                                        }}
                                    >
                                        {data.row.original.memo}
                                    </div>
                                ]}
                            />
                        );
                    }

                    if (!this.props.currentPermission.download && !this.props.currentPermission.playback) {
                        return "-";
                    }
                } else if (data.row.original.voice_del_flag === "Y") {
                    let speechBubbleData = [];
                    if (data.row.original.voice_deleted) {
                        speechBubbleData.push(<div>{moment(data.row.original.voice_deleted).utc()
                            .add(9, "h").format("YYYY/MM/DD HH:mm")}</div>);
                    }
                    if (data.row.original.voice_deleted_user_id) {
                        speechBubbleData.push(<div>{data.row.original.voice_deleted_user_id
                            + " " + this.props.langText.Message.Record_VoiceDeleted}</div>)
                    }
                    rowData.push(<ButtonSpeechBubble
                        key = {data.row.original.id + "_voice_deleted"}
                        size="sm"
                        className="control-button-disabled"
                        DisplayIcon={faMinus}
                        speechBubble={speechBubbleData}
                    />);
                } else {}
                return (
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        width: '100%',
                    }}>
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: window.innerWidth < 768 ? 'repeat(auto-fit, minmax(60px, 1fr))' : 'repeat(4, 1fr)',
                            gap: '4px',
                            alignItems: 'center',
                            width: '140px',
                        }}>
                            {rowData}
                        </div>
                    </div>
                );
            }
        })

        if (this.getLevelGreaterEqual(GlobalConst.LEVEL_OBJECT.company)) {
            let companyArray = [
                {
                    Header: this.props.langText.Body.UserId,
                    width: this.props.boardWidth.smedium,
                    accessor: "hm15_user.user_id",
                }
            ]
            return companyArray.concat(returnArray);
        } else {
            return returnArray;
        }
    }

    modalShow = (modalType, param) => async event => {
        event.preventDefault();
        try{
            this.toggleBlocking();
            let res = await this.ascAxios(
                'post',
                `${this.reactContainerPath}/getS3PreSignedUrl`,
                {id: param.value}
            );
            switch (modalType) {
                case 'download':
                    window.location.href = res.data;
                    break;
                case 'playback':
                    // 並列実行で高速化
                    let [text, memoData] = await Promise.all([
                        this.ascAxios('post',
                            `Record/getVoiceLogToTextByHt60id`,
                            {ht60_id: param.row.original.id}),
                        this.ascAxios('post',
                            `Record/getMemo`,
                            {ht60_id: param.row.original.id})
                    ]);

                    this.setState({
                        id: param.row.original.id,
                        external_number: param.row.original.external_number,
                        extension_number: param.row.original.extension_number,
                        dest_tel_number: param.row.original.dest_tel_number,
                        inout_type: param.row.original.inout_type,
                        answer_datetime: param.row.original.answer_datetime,
                        customer_id: param.row.original.hm01_customer_info
                            ? param.row.original.hm01_customer_info.id : "",
                        customer_name: param.row.original.hm01_customer_info
                            ? param.row.original.hm01_customer_info.name : "",
                        url: res.data,
                        ht87_voice_log_to_text: text && text.data && text.data.ht87_voice_log_to_text
                            && text.data.ht87_voice_log_to_text,
                        ht88_voice_log_to_analyze: param.row.original.ht88_voice_log_to_analyze,
                        ht88_categories: param.row.original.ht88_voice_log_to_analyze
                            ? param.row.original.ht88_voice_log_to_analyze.categories : "",
                        ht88_analysis_data: param.row.original.ht88_voice_log_to_analyze
                            ? param.row.original.ht88_voice_log_to_analyze.analysis_data : "",
                        s3_object_key: param.row.original.s3_object_key
                            ? param.row.original.s3_object_key.split("/")[1] : "",
                        memo: memoData && memoData.data ? memoData.data.memo : "",
                        show: true,
                        modalType
                    });
                    break;
                default:
                    this.showErrorObjectMessage({message: 'modal'});
                    break;
            }
            this.toggleBlocking();
        } catch (e) {
            this.showErrorObjectMessage(e);
            this.toggleBlocking();
        }

    }

    /**
     * リスト画面のメモデータを更新する
     * @param {number} recordId - 更新対象の通話記録ID
     * @param {string} newMemo - 新しいメモの内容
     */
    updateListMemo = (recordId, newMemo) => {
        const updatedData = this.state.data.map(record => {
            if (record.id === recordId) {
                return { ...record, memo: newMemo };
            }
            return record;
        });
        this.setState({ data: updatedData });
    }

    /**
     * modalTypeにより分岐させる
     */
    getModalBranch = () => {
        switch (this.state.modalType) {
            case "playback":
                return (
                    <RecordPlaybackModal
                        state = {this.state}
                        reactTableRefresh = {this.reactTableRefresh}
                        propSetState = {this.propSetState}
                        langText = {this.props.langText}
                        charaLimit = {this.props.charaLimit}
                        boardWidth={this.props.boardWidth}
                        onClick = {this.onClickHandle}
                        downloadCallContents = {this.downloadCallContents}
                        validationHandle = {this.validationHandle}
                        showErrorObjectMessage = {this.showErrorObjectMessage}
                        options={this.props.userInfo.options}
                        currentPermission={this.props.currentPermission}
                        // 【#549】currentPermission は URL パス由来の画面別権限である。
                        // メモと通話分類はサーバーが permission_data.Record.update だけを見るため、
                        // Record 権限を別 props で明示的に渡す（電話帳経路と判定を揃える）。
                        recordPermission={this.props.userInfo.permission_data
                            && this.props.userInfo.permission_data.Record}
                        secToTime={this.secToTime}
                        ascAxios = {this.ascAxios}
                        updateListMemo = {this.updateListMemo}
                        onAudio2TextRetryStart = {this.onAudio2TextRetryStart}
                        categoryMaster={this.state.categoryOptions}/>
                );
            case "vocAnalysis":
                return (
                    <RecordVocAnalysisModal
                        state={this.state}
                        propSetState={this.propSetState}
                        langText={this.props.langText}
                        validationHandle={this.validationHandle}
                        onClick={this.onClickHandle}
                        vocCategoryOptions={this.state.vocCategoryOptions}
                        selectedVocCategories={this.state.selectedVocCategories}
                        onVocCategoryToggle={this.onVocCategoryToggle}
                        onVocReportMemoChange={this.onVocReportMemoChange}
                    />
                );
            default:
                break;
        }
    }

    onClickHandle = modalType => async () => {
        this.toggleBlocking();
        try {
            switch (modalType) {
                case "playback":
                    await new Promise(resolve => setTimeout(resolve, 5000));
                    this.setState({show: false});
                    break;
				case "vocAnalysis":
					// モーダル内ローディングを表示し、完了/失敗で閉じるかを分岐
					this.setState({ loadingDisplayFlag: true });
					{
						const ok = await this.executeVocAnalysis();
						this.setState({ loadingDisplayFlag: false, show: ok ? false : true });
					}
					break;
                case "delete":
                    // this.setState({show: false});
                    break;
                default:
                    this.showErrorObjectMessage({message: 'ModalTypeError'});
                    break;
            }
        } finally {
            this.toggleBlocking();
        }
    }

    /**
     * VoC分析レポート作成
     */
		executeVocAnalysis = async () => {
		try {
			// 1) サーバーへ検索条件を渡して、条件に合致し文字起こしがある全件の ht60_id 一覧を取得
			const idsRes = await this.ascAxios('post', `Record/getVocEligibleIds`, { filtered: this.state.hidden_filtered || [] });
			const allIds = idsRes && idsRes.data && Array.isArray(idsRes.data.ids) ? idsRes.data.ids : [];
			const voice_data = allIds.map(id => ({ ht60_id: Number(id) })).filter(r => Number.isFinite(r.ht60_id));
			if (!voice_data.length) {
				this.showErrorObjectMessage({ message: 'FindDataError' });
				return false;
			}

			// 2) レポート名生成 VocReport_YYYYMMDDhhmmss（サーバー側で32文字に切詰め済み）
			const report_name = `${this.props.langText.Body.VocReport}_${moment(new Date()).format('YYYYMMDDHHmmss')}`;

			// 3) サーバーへ委譲してBatch起動（非同期ジョブ化）
			const payload = {
				voice_data,
				// 以降の互換のため search_condition は残すが、サーバーは voice_data の ht60_id を使用
				search_condition: this.convertFiltersToSearchCondition(this.state.hidden_filtered || []),
				voc_report_setting: { report_name, memo: this.state.voc_report_memo || '' },
				// VoCカテゴリリスト（選択されたカテゴリ情報の配列）
				// フィールド名を期待される形式にマッピング
				voc_category_list: (this.state.selectedVocCategories || []).map(cat => ({
					voc_category_id: cat.voc_categories_uuid,
					category_name: cat.category_name,
					prompt_text: cat.voc_llm_prompt,
					created: cat.created_at || cat.created,
					updated: cat.updated_at || cat.updated
				}))
			};
			const kickoff = await this.ascAxios('post', `VocAnalysis/generateReport`, payload);
			// サーバーは 202 + jobId を返す想定
			const jobId = kickoff && kickoff.data && kickoff.data.jobId ? kickoff.data.jobId : null;
			if (!jobId) {
				this.showErrorObjectMessage({ message: 'GetDataError_Server' });
				return;
			}

			// 4) 受け付け完了後はダイアログで通知し、赤文字メッセージの表示は行わない
			alert(this.props.langText.Message.VocAnalysisKickoff);
			this.setState({ search_message: '' });
			return true;
		} catch (e) {
			this.showErrorObjectMessage(e);
			return false;
		}
    }

    /**
     * VoC分析モーダルを開く際に件数を最新化する
     */
    openVocAnalysisModal = async () => {
        try {
            await this.onSearch();
            await this.getAudio2TextUsageMonth();
            if (this.state.count === null) {
                this.showErrorObjectMessage({ message: 'GetDataError_Server' });
                return;
            }

            // VoCカテゴリ一覧を先に取得（モーダル表示前に完了させる）
            let vocCategoryOptions = [];
            try {
                const res = await this.ascAxios('post', `VocCategory/board`, { offset: 0, limit: 100 });
                vocCategoryOptions = res && res.data && res.data.rows ? res.data.rows : [];
            } catch (e) {
                console.error('VoCカテゴリ取得エラー:', e);
                vocCategoryOptions = [];
            }

            // モーダルを表示（VoCカテゴリデータも含めて初期化）
            this.setState({
                show: true,
                modalType: "vocAnalysis",
                voc_report_memo: '',
                selectedVocCategories: [],
                vocCategoryOptions: vocCategoryOptions
            });

            // 対象件数（AI録音文字起こしあり）を取得（非同期で更新）
            (async () => {
                try {
                    const res = await this.ascAxios('post', `Record/getVocEligibleCount`, { filtered: this.state.hidden_filtered || [] });
                    const eligible = res && res.data && typeof res.data.count === 'number' ? res.data.count : 0;
                    this.setState({ voc_eligible_count: eligible });
                } catch (e) {
                    console.error('VoC対象件数取得エラー:', e);
                    this.setState({ voc_eligible_count: 0 });
                }
            })();
        } catch (e) {
            this.showErrorObjectMessage(e);
        }
    }

    /**
     * VoCカテゴリの選択変更
     * @param {Array} categories - 選択されたカテゴリの配列
     */
    onVocCategoryToggle = (categories) => {
        this.setState({
            selectedVocCategories: categories || []
        });
    }

    /**
     * VoC分析メモの変更
     * @param {string} memo - メモの内容
     */
    onVocReportMemoChange = (memo) => {
        this.setState({
            voc_report_memo: memo
        });
    }

    // 検索条件(filtered)をAPI仕様のsearch_conditionに変換
    convertFiltersToSearchCondition = (filtered) => {
        const cond = {};
        const getVal = (id) => {
            const f = filtered.find(r => r.id === id);
            return f ? f.value : undefined;
        }
        const start = getVal('answer_datetime');
        const end = getVal('end_datetime');
        if (start) cond.start_date = moment(start).format('YYYY-MM-DD');
        if (end) cond.end_date = moment(end).format('YYYY-MM-DD');
        [
            'user_id',
            'extension_number',
            'dest_tel_number',
            'inout_type',
            'customer_name',
            'keyword',
            'categories_search'
        ].forEach(key => {
            const val = getVal(key);
            if (val !== undefined) cond[key] = val;
        });
        // Issue #289: Record search - 複数外線番号検索（新形式）
        const externalNumbers = getVal('external_numbers');
        if (externalNumbers !== undefined) cond.external_numbers = externalNumbers;
        return cond;
    }

    validationHandle = param => {
        let validation_flag = false;
        switch (param) {
            case "playback":
                validation_flag = true;
                break;
            case "vocAnalysis":
                validation_flag = true;
                break;
            default:
                break;
        }
        return validation_flag;
    }

    /**
     * 必要な検索条件が入っているか確認
     */
    checkFilterValid = () => {
        let search_message = "";
        if(
            !this.getFilterData("user_id")
        ){
            search_message = this.props.langText.Message.Validation_Record_System;
            this.setState({
                search_flag: false,
                search_message
            });
        } else if(this.getFilterData("answer_datetime") && this.getFilterData("end_datetime")
            && (this.getFilterData("end_datetime") - this.getFilterData("answer_datetime")) <= 0){
            search_message = this.props.langText.Message.Validation_DateTime;
            this.setState({
                search_flag: false,
                search_message
            });
        } else {
            this.setState({
                search_flag: true,
                search_message
            });
        }
    }

    onChange = async (event, param) => {
        let my_filtered = [...this.state.hidden_filtered],
            target_index = my_filtered.findIndex(row => row.id === param),
            value = "";
        // セレクトボックス用。event無い場合はvalue空のまま
        if (event) {
            value = event.target ? event.target.value : event;
        }

        if (target_index !== -1) {
            my_filtered.splice(target_index, 1);
        }

        // keyword と categories_search の特別処理（空配列でも処理が必要）
        // Issue #289: Record search - 外線番号複数選択処理
        if (param === "external_numbers") {
            if (event && event.length > 0) {
                my_filtered.push({
                    id: param,
                    value: event.map(opt => opt.value)
                });
            }
            // 1回の setState にまとめて余分な再レンダリングを避ける
            await this.setState({
                selectedExternalNumbers: event || [],
                hidden_filtered: my_filtered,
            });
            this.checkFilterValid();
            return;
        } else if (param === "keyword") {
            if (event && event.length > 0) {
                my_filtered.push({
                    id: param,
                    value: event.map((keyword) => keyword.value)
                });
            }
            await this.setState({keywords: event || []});
        } else if (param === "categories_search") {
            // categoriesSearchには、既存のカテゴリのrgbとfont_rgbを保持する
            const enrichedCategories = event ? event.map((category) => {
                // Mapから一致するカテゴリを探す（高速化）
                const matchedOption = this.categoryOptionsMap.get(category.value);
                return {
                    value: category.value,
                    label: category.label,
                    rgb: matchedOption ? matchedOption.rgb : (category.rgb || DEFAULT_CATEGORY_BG_COLOR),
                    font_rgb: matchedOption ? matchedOption.font_rgb : (category.font_rgb || DEFAULT_CATEGORY_FONT_COLOR)
                };
            }) : [];

            if (enrichedCategories.length > 0) {
                my_filtered.push({
                    id: param,
                    value: enrichedCategories.map((category) => category.value)
                });
            }
            await this.setState({categoriesSearch: enrichedCategories});
        } else if (value && (!Array.isArray(value) || value.length)) {
            // その他のパラメータの通常処理
            if ((param === "end_datetime" || param === "answer_datetime")
                && ((!this.getFilterData(param) || (this.getFilterData(param)
                    && (moment(this.getFilterData(param)).year() !== moment(value).year()
                        || moment(this.getFilterData(param)).month() !== moment(value).month()
                        || moment(this.getFilterData(param)).day() !== moment(value).day()))))) {
                value.setHours(param === "answer_datetime" ? 0 : 23, param === "answer_datetime" ? 0 : 59)
            }
            my_filtered.push({
                id: param,
                value
            });

            if (param === "inout_type" && value === "all"){
                my_filtered = my_filtered.filter((elm)=> elm.param !== "inout_type" && elm.value !== "all")
            } else if (param === "answer_datetime" && !this.getFilterData("end_datetime")) {
                let cp = new Date(value);
                cp.setHours(23,59);
                my_filtered.push({
                    id: "end_datetime",
                    value: cp
                });
            } else if (param === "end_datetime" && !this.getFilterData("answer_datetime")) {
                let cp = new Date(value);
                cp.setHours(0,0);
                my_filtered.push({
                    id: "answer_datetime",
                    value: cp
                });
            }
        }

        // Issue #289: Record search - user_id 変更時は external_numbers フィルタも同時に解除する
        // hidden_filtered の二重更新を避けるため、ここでまとめて整形してから setState する
        if (param === "user_id") {
            my_filtered = my_filtered.filter(r => r.id !== "external_numbers");
            await this.setState({
                selectedExternalNumbers: [],
                hidden_filtered: my_filtered,
            });
            this.checkFilterValid();
            const newUserId = value || this.props.userInfo.user_id;
            this.getExternalNumberOptions(newUserId);
            return;
        }

        await this.setState({hidden_filtered: my_filtered});
        this.checkFilterValid();
    }

    getFilterData(param) {
        let my_param_data = this.state.hidden_filtered.find(row => row.id === param);
        return my_param_data ? my_param_data.value : "";
    }

    onSearch = async () => {
        if (!this.getFilterData("end_datetime") && this.getFilterData("answer_datetime")) {
            if (addYears(this.getFilterData("answer_datetime"), + 1) > new Date()) {
                await this.onChange(new Date(), "end_datetime");
            } else {
                await this.onChange(addYears(this.getFilterData("answer_datetime"), + 1), "end_datetime");
            }
        } else if (this.getFilterData("end_datetime") && !this.getFilterData("answer_datetime")) {
            await this.onChange(addYears(this.getFilterData("end_datetime"), - 1), "answer_datetime");
        } else if (!this.getFilterData("end_datetime") && !this.getFilterData("answer_datetime")) {
            await this.onChange(addYears(new Date(), - 1), "answer_datetime");
            await this.onChange(new Date(), "end_datetime");
        }
        await this.setState({filtered: this.state.hidden_filtered, count: "-"});
        await this.reactTableRefresh();
    }

    async getAudio2TextUsageMonth() {
        let result = await this.ascAxios('post', `${this.reactContainerPath}/getAudio2TextUsageMonth`, {});
        if (result && result.data && result.data.audio2text_usage_month >= 0) {
            await this.setState({audio2text_usage_month: result.data.audio2text_usage_month});
        }
    }

    /**
     * 通話分類マスターデータを取得
     */
    async getCategoryMasterData() {
        // 【#583】通話分類は Anywhere 側のデータで、RecACE plus の契約が無いユーザーは
        // Anywhere に登録が無い。取得すると Unauthorized → 500 になり、ログインのたびに
        // ダイアログが出ていた。通話分類の列・検索欄と同じ判定で取得自体を行わない。
        if (!hasRecAceContract(this.props.userInfo.options)) {
            await this.setState({ categoryOptions: [] });
            return;
        }
        try {
            const result = await this.ascAxios('post', 'Category/board', {
                page: 0,
                pageSize: 1000
            });
            if (result && result.data && result.data.rows) {
                const categoryOptions = result.data.rows.map(category => ({
                    value: category.name,
                    label: category.name,
                    rgb: category.rgb || DEFAULT_CATEGORY_BG_COLOR,
                    font_rgb: category.font_rgb || DEFAULT_CATEGORY_FONT_COLOR,
                    data: category
                }));
                this.categoryOptionsMap = new Map(
                    categoryOptions.map(opt => [opt.value, opt])
                );
                await this.setState({ categoryOptions });
            } else {
                await this.setState({ categoryOptions: [] });
            }
        } catch (error) {
            console.error('通話分類マスターデータ取得エラー:', error);
            await this.setState({ categoryOptions: [] });
            this.showErrorObjectMessage({
                message: '通話分類マスターデータの取得に失敗しました。'
            });
        }
    }

    /**
     * Issue #289: Record search
     * 指定ユーザーの外線番号候補リストを取得する。
     * user_id フィルタ変更時にも呼び出す。
     * @param {string} userId - ユーザーID
     */
    async getExternalNumberOptions(userId) {
        if (!userId) return;
        try {
            // APIの取得失敗時はオプションを空にしてフォールバック（フォーム自体は機能する）
            const result = await this.ascAxios('post', 'Common/getExternalNumberByUser', { user_id: userId });
            if (result && result.data && Array.isArray(result.data)) {
                // APIレスポンス: [{value, label, name}] 形式を期待
                // value: 外線番号（数字のみ正規化済み）, label: 表示番号, name: description
                const options = result.data.map(row => ({
                    value: normalizeExternalNumber(row.value || row.external_number || ''),
                    label: row.label || row.external_number || '',
                    name: row.name || row.description || ''
                }));
                // 外線番号→名称マップを構築（一覧/CSV表示用）
                const externalNumberMap = {};
                options.forEach(opt => {
                    if (opt.value && opt.name) {
                        externalNumberMap[opt.value] = opt.name;
                    }
                });
                await this.setState({ externalNumberOptions: options, externalNumberMap });
            } else {
                await this.setState({ externalNumberOptions: [], externalNumberMap: {} });
            }
        } catch (error) {
            // APIが未実装または失敗時は空オプションで続行（検索フォームは機能する）
            await this.setState({ externalNumberOptions: [], externalNumberMap: {} });
        }
    }

    // 通話内容をテキストファイルに変換
    downloadCallContents = async (rowData) => {
        if (!this.state.data || this.state.data.length === 0) {
            this.showErrorObjectMessage({message: "NoDataToDownload"});
            return;
        }

        try {
            let voiceLogToText = await this.ascAxios('post', `Record/getVoiceLogToTextByHt60id`, {ht60_id: rowData.id});
            let content = "";

            // 通話分類
            if (rowData.ht88_categories && rowData.ht88_categories.length > 0) {
                content += `【${this.props.langText.Body.CallCategory}】\n`;
                for (let i = 0; i < rowData.ht88_categories.length; i++) {
                    content += rowData.ht88_categories[i].name;
                    if (i < rowData.ht88_categories.length - 1) {
                        content += "、";
                    } else {
                        content += "\n\n";
                    }
                }
            }

            // 通話概要
            if (rowData.ht88_analysis_data) {
                content += `【${this.props.langText.Body.CallAnalysisData}】\n`;
                content += rowData.ht88_analysis_data + "\n\n";
            }

            // AI録音文字起こし
            if (voiceLogToText && voiceLogToText.data && voiceLogToText.data.ht87_voice_log_to_text) {
                let ht87_voice_log_to_text = voiceLogToText.data.ht87_voice_log_to_text;
                content += `【${this.props.langText.Body.audio2text}】\n`;
                for (let i = 0; i < ht87_voice_log_to_text.text_data_json.length; i++) {
                    let inout_type = ht87_voice_log_to_text.text_data_json[i].inout === "in" 
                        ? this.props.langText.Body.Client : this.props.langText.Body.User;
                    content += this.secToTime(Math.floor(ht87_voice_log_to_text.text_data_json[i].start)) 
                    + ` (${inout_type}) ` + ht87_voice_log_to_text.text_data_json[i].text + "\n\n";
                }
            }

            // テキストファイルをダウンロード
            const blob = new Blob([content], { type: CALL_TEXT_DOWNLOAD.MIME_TYPE });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", buildCallTextDownloadFilenameFromPlaybackState(rowData));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (error) {
            this.showErrorObjectMessage({message: "DownloadError"});
        }
    }

    /**
     * CSVダウンロードメソッド
     */
    downloadSearchResultsCSV = async () => {
        try {
            // 件数チェック
            const totalCount = parseInt(this.state.count);

            if (totalCount > 10000) {
                this.showErrorObjectMessage({
                    message: 'Record_CsvDownloadLimit'
                });
                return;
            }

            await this.setState({ csvDownloading: true });

            // サーバーから全件データ取得
            const result = await this.ascAxios('post', 'Record/exportSearchResultsCSV', {
                filtered: this.state.hidden_filtered || []
            });

            if (!result || !result.data || !result.data.rows) {
                this.showErrorObjectMessage({ message: 'FindDataError' });
                return;
            }

            // CSV生成
            const csvContent = this.generateCSV(result.data.rows);

            // ダウンロード実行
            const filename = `録音音声一覧_${moment().format('YYYYMMDD_HHmmss')}.csv`;
            this.downloadCSVFile(csvContent, filename);

        } catch (error) {
            console.error('CSV download error:', error);
            this.showErrorObjectMessage({ message: 'Record_CsvDownloadError' });
        } finally {
            await this.setState({ csvDownloading: false });
        }
    }

    /**
     * CSV生成メソッド
     * @param {Array} data - 録音音声データ配列
     * @returns {string} CSV形式の文字列
     */
    generateCSV = (data) => {
        // Issue #349: CSV列は一覧の列表示と同じく契約有無で判定
        const hasRecACEPlus = hasRecAceContract(this.props.userInfo.options);
        const hasAspire = !!(this.props.userInfo.options && this.props.userInfo.options.aspire);

        // ヘッダー行
        const headers = [
            '外線番号'
        ];
        if (hasAspire) {
            headers.push('内線番号');
        }
        headers.push(
            '相手先番号',
            '発着信',
            '通話日時',
            '通話時間',
            'メモ'
        );

        if (hasRecACEPlus) {
            headers.push('通話分類', '顧客名', '通話要約');
        }

        // データ行
        const rows = data.map(record => {
            // Issue #289: Record search - 外線番号にCSV名称を併記
            const extNum = record.external_number || '';
            const extName = this.state.externalNumberMap[normalizeExternalNumber(extNum)];
            const extNumDisplay = extName ? `${extNum} (${extName})` : extNum;
            const row = [
                this.escapeCsvValue(extNumDisplay)
            ];
            if (hasAspire) {
                row.push(this.escapeCsvValue(record.extension_number || ''));
            }
            row.push(
                this.escapeCsvValue(record.dest_tel_number || ''),
                this.formatInOutType(record.inout_type),
                this.formatDateTime(record.answer_datetime),
                this.formatCallDuration(record.billsec),
                this.escapeCsvValue(record.memo || '')
            );

            if (hasRecACEPlus) {
                row.push(
                    this.formatCategories(record.ht88_categories),
                    this.escapeCsvValue(record.ht88_customer_name || ''),
                    this.escapeCsvValue(record.ht88_analysis_data_overview || '')
                );
            }

            return row.join(',');
        });

        // BOM付きUTF-8
        const BOM = '\uFEFF';
        return BOM + [headers.join(','), ...rows].join('\n');
    }

    /**
     * CSVエスケープ処理（インジェクション対策含む）
     * @param {*} value - エスケープする値
     * @returns {string} エスケープされた値
     */
    escapeCsvValue = (value) => {
        if (value === null || value === undefined) return '';
        let str = String(value);

        // CSVインジェクション対策
        if (/^[=+\-@]/.test(str)) {
            str = "'" + str;
        }

        // 特殊文字エスケープ
        if (str.includes(',') || str.includes('\n') || str.includes('"')) {
            return `"${str.replace(/"/g, '""')}"`;
        }
        return str;
    }

    /**
     * 発着信タイプの日本語変換
     * @param {string} inout_type - 発着信タイプ（in/out）
     * @returns {string} 日本語の発着信表示
     */
    formatInOutType = (inout_type) => {
        if (inout_type === 'in') return this.props.langText.Body.Incoming;
        if (inout_type === 'out') return this.props.langText.Body.Outgoing;
        return '';
    }

    /**
     * 日時フォーマット
     * @param {string} datetime - 日時文字列
     * @returns {string} YYYY-MM-DD HH:mm:ss 形式
     */
    formatDateTime = (datetime) => {
        if (!datetime) return '';
        return moment(datetime).utc().add(9, 'h').format('YYYY-MM-DD HH:mm:ss');
    }

    /**
     * 通話時間フォーマット
     * @param {number} seconds - 秒数
     * @returns {string} HH:mm:ss 形式
     */
    formatCallDuration = (seconds) => {
        if (!seconds || seconds === 0) return '00:00:00';
        return this.secToTime(seconds);
    }

    /**
     * 通話分類のフォーマット（スラッシュ区切り）
     * @param {Array} categories - カテゴリ配列
     * @returns {string} スラッシュ区切りのカテゴリ名
     */
    formatCategories = (categories) => {
        if (!categories || !Array.isArray(categories) || categories.length === 0) {
            return '';
        }
        const names = categories.map(cat => (cat && cat.name) || '').filter(n => n);
        return this.escapeCsvValue(names.join('/'));
    }

    /**
     * CSVファイルダウンロード実行
     * @param {string} content - CSV内容
     * @param {string} filename - ファイル名
     */
    downloadCSVFile = (content, filename) => {
        const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(url);
    }

    render() {
        // 発着信フィルタは Aspire オプション ON/OFF で配置先が変わるため変数として抽出 (中身は共通)
        const inOutTypeFilter = (
            <>
                <Col sm={4} md={2} lg={1}>
                    <div className="record-search-label">{this.props.langText.Body.InOutType}</div>
                </Col>
                <Col xs={12} sm={12} md={6} lg={2}>
                    <ButtonGroup className = "record-btn-grp">
                        <Button
                            className = {`record-inout-btn ${this.state.hidden_filtered.some(row => row.id === "inout_type") ? "" : "record-inout-btn-focus"}`}
                            value = "all"
                            onClick = {e => this.onChange(e, "inout_type")}
                        >
                            {this.props.langText.Body.AllType}
                        </Button>
                        <Button
                            className = {`record-inout-btn ${this.state.hidden_filtered.some(row => row.id === "inout_type" && row.value === "in") ? "record-inout-btn-focus" : ""}`}
                            value = "in"
                            onClick = {e => this.onChange(e, "inout_type")}
                        >
                            {this.props.langText.Body.Incoming}
                        </Button>
                        <Button
                            className = {`record-inout-btn ${this.state.hidden_filtered.some(row => row.id === "inout_type" && row.value === "out") ? "record-inout-btn-focus" : ""}`}
                            value = "out"
                            onClick = {e => this.onChange(e, "inout_type")}
                        >
                            {this.props.langText.Body.Outgoing}
                        </Button>
                    </ButtonGroup>
                </Col>
            </>
        );

        return (
            <div className="Record">
                <Row>
                    <div className="record-message">
                        {this.state.search_message}
                    </div>
                </Row>
                {/* 【#588】検索条件を枠で囲む。高さは #587 の表の高さ計算に使う */}
                <div className="record-search-panel" ref={this.searchPanelRef}>
                {/* 1行目: 日時、~、ワード検索、ユーザーID */}
                <Row className="record-search-row">
                    <Col sm={12} md={2} lg={1}>
                        <div className="record-search-label">{this.props.langText.Body.DateTime}</div>
                    </Col>
                    <Col xs={5} sm={5} md={3} lg={2} className="date-picker-frame">
                        <DatePicker
                            isClearable={true}
                            onChange={e => this.onChange(e, "answer_datetime")}
                            selected={this.getFilterData("answer_datetime") ? this.getFilterData("answer_datetime") : null}
                            className="date-picker form-control"
                            maxDate={this.getFilterData("end_datetime")
                                ? this.getFilterData("end_datetime") : new Date()}
                            minDate={this.getFilterData("end_datetime")
                                ? addYears(this.getFilterData("end_datetime"), - 1) : null}
                            locale="ja"
                            todayButton={this.props.langText.Body.Today}
                            placeholderText={this.props.langText.Body.StartDateTime}
                            dropdownMode="select"
                            timeInputLabel={this.props.langText.Body.TimeMin}
                            dateFormat="yyyy/MM/dd HH:mm"
                            showTimeInput
                            shouldCloseOnSelect={false}
                        />
                    </Col>
                    <Col xs={1} sm={1} md={1} lg={1}>
                        <div className="record-search-label">~</div>
                    </Col>
                    <Col xs={5} sm={5} md={3} lg={2} className="date-picker-frame">
                        <DatePicker
                            isClearable={true}
                            onChange={e => this.onChange(e, "end_datetime")}
                            selected={this.getFilterData("end_datetime") ? this.getFilterData("end_datetime") : null}
                            className="date-picker form-control"
                            maxDate={
                                this.getFilterData("answer_datetime")
                                    ? addYears(this.getFilterData("answer_datetime"), 1) < new Date()
                                        ? addYears(this.getFilterData("answer_datetime"), 1)
                                        : new Date()
                                    : new Date()
                            }
                            minDate={this.getFilterData("answer_datetime")
                                ? this.getFilterData("answer_datetime") : null}
                            locale="ja"
                            todayButton={this.props.langText.Body.Today}
                            placeholderText={this.props.langText.Body.EndDateTime}
                            dropdownMode="select"
                            timeInputLabel={this.props.langText.Body.TimeMin}
                            dateFormat="yyyy/MM/dd HH:mm"
                            showTimeInput
                            shouldCloseOnSelect={false}
                        />
                    </Col>
                    <Col sm={12} md={2} lg={1}>
                        <div className="record-search-label">{this.props.langText.Body.KeywordSearch}</div>
                    </Col>
                    <Col sm={12} md={4} lg={2}>
                        <Creatable
                            isMulti
                            isClearable={true}
                            value={this.state.keywords}
                            placeholder={this.props.langText.Message.Validation_TextSearch}
                            onChange = {e => this.onChange(e, "keyword")}
                            noOptionsMessage={() => this.props.langText.Message.Validation_TextSearch}
                            formatCreateLabel={(inputText) => `${inputText} ${this.props.langText.Message.Creating}`}
                        />
                    </Col>
                    {/* Issue #349: 通話分類検索欄は通話分類列と同じく契約有無で判定 */}
                    {hasRecAceContract(this.props.userInfo.options) ? (
                        <>
                            <Col sm={12} md={2} lg={1}>
                                <div className="record-search-label">{this.props.langText.Body.CategoriesSearch}</div>
                            </Col>
                            <Col sm={12} md={4} lg={2}>
                        <Creatable
                            isMulti
                            isClearable={true}
                            value={this.state.categoriesSearch}
                            options={this.state.categoryOptions}
                            placeholder={this.props.langText.Body.CategoriesSearchPlaceholder}
                            onChange = {e => this.onChange(e, "categories_search")}
                            noOptionsMessage={() => this.props.langText.Body.CategoriesSearchNoOptions}
                            formatCreateLabel={(inputText) => `${inputText}${this.props.langText.Body.CategoriesSearchCreateLabel}`}
                            components={{
                                MultiValue: (props) => {
                                    const backgroundColor = props.data.rgb || '#808080';
                                    const color = props.data.font_rgb || '#ffffff';
                                    return (
                                        <div
                                            style={{
                                                backgroundColor: backgroundColor,
                                                color: color,
                                                borderRadius: '4px',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                margin: '2px',
                                                padding: '2px 6px',
                                                fontSize: '14px'
                                            }}
                                        >
                                            <span>{props.data.label}</span>
                                            <span
                                                onClick={props.removeProps.onClick}
                                                onTouchEnd={props.removeProps.onTouchEnd}
                                                onMouseDown={props.removeProps.onMouseDown}
                                                style={{
                                                    marginLeft: '6px',
                                                    cursor: 'pointer',
                                                    fontSize: '16px',
                                                    fontWeight: 'bold'
                                                }}
                                            >
                                                ×
                                            </span>
                                        </div>
                                    );
                                },
                                Option: (props) => {
                                    const backgroundColor = props.data.rgb || '#808080';
                                    const color = props.data.font_rgb || '#ffffff';
                                    return (
                                        <div
                                            ref={props.innerRef}
                                            {...props.innerProps}
                                            style={{
                                                backgroundColor: props.isFocused ? '#f0f0f0' : 'white',
                                                padding: '8px 12px',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            <span
                                                style={{
                                                    backgroundColor: backgroundColor,
                                                    color: color,
                                                    borderRadius: '4px',
                                                    padding: '2px 8px',
                                                    fontSize: '14px',
                                                    display: 'inline-block'
                                                }}
                                            >
                                                {props.data.label}
                                            </span>
                                        </div>
                                    );
                                }
                            }}
                            styles={{
                                multiValue: (base) => ({
                                    ...base,
                                    backgroundColor: 'transparent',
                                    margin: 0,
                                    padding: 0
                                }),
                                multiValueLabel: (base) => ({
                                    ...base,
                                    padding: 0,
                                    paddingLeft: 0
                                }),
                                multiValueRemove: (base) => ({
                                    ...base,
                                    display: 'none'
                                }),
                                menu: (base) => ({
                                    ...base,
                                    zIndex: 9999
                                }),
                                menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999
                                })
                            }}
                            menuPortalTarget={document.body}
                        />
                            </Col>
                        </>
                    ) : (
                        <>
                            <Col sm={4} md={2} lg={1}
                                 hidden={!this.getLevelGreaterEqual(GlobalConst.LEVEL_OBJECT.company)}
                            >
                                <div className="record-search-label">{this.props.langText.Body.UserId}</div>
                            </Col>
                            <Col sm={12} md={4} lg={2}
                                 hidden={!this.getLevelGreaterEqual(GlobalConst.LEVEL_OBJECT.company)}
                            >
                                <FormControl
                                    onChange = {
                                        e => this.onChange(e, "user_id")
                                    }
                                    value = {this.getFilterData("user_id")}
                                />
                            </Col>
                        </>
                    )}
                </Row>
                {/* 2行目: 外線番号、顧客名、相手先番号、発着信 Issue #289: 外線番号をプルダウン化（複数選択+名称対応） */}
                <Row className="record-search-row">
                    <Col sm={4} md={2} lg={1}>
                        <div className="record-search-label">{this.props.langText.Body.ExternalNumber}</div>
                    </Col>
                    <Col sm={12} md={4} lg={2}>
                        <Select
                            isMulti
                            isClearable
                            value={this.state.selectedExternalNumbers}
                            options={this.state.externalNumberOptions}
                            placeholder={this.props.langText.Body.ExternalNumberSearchPlaceholder}
                            noOptionsMessage={() => this.props.langText.Body.ExternalNumberSearchNoOptions}
                            onChange={e => this.onChange(e, "external_numbers")}
                            filterOption={(option, inputValue) => {
                                // 番号（label）と名称（name）の両方でインクリメンタル検索
                                // option.data の存在しないケースに備えて optional chaining で防御
                                if (!inputValue) return true;
                                const search = inputValue.toLowerCase();
                                const labelMatch = (option.label || '').toLowerCase().includes(search);
                                const nameMatch = ((option.data && option.data.name) || '').toLowerCase().includes(search);
                                return labelMatch || nameMatch;
                            }}
                            getOptionLabel={option => {
                                // 名称あり: "03-1234-5678 (営業部)", 名称なし: "03-1234-5678"
                                return option.name ? `${option.label} (${option.name})` : option.label;
                            }}
                            styles={{
                                // フィールド自体は狭くても、メニュー（候補リスト）は名称表示のため広く取る
                                menu: (base) => ({ ...base, width: 'max-content', minWidth: '100%', maxWidth: '500px', zIndex: 9999 }),
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                            menuPortalTarget={document.body}
                        />
                    </Col>
                    {!!(this.props.userInfo.options && this.props.userInfo.options.aspire) && (
                        <>
                            <Col sm={4} md={2} lg={1}>
                                <div className="record-search-label">{this.props.langText.Body.ExtensionNumber}</div>
                            </Col>
                            <Col sm={12} md={4} lg={2}>
                                <FormControl
                                    onChange = {
                                        e => this.onChange(e, "extension_number")
                                    }
                                    value = {this.getFilterData("extension_number")}
                                />
                            </Col>
                        </>
                    )}
                    <Col sm={4} md={2} lg={1}>
                        <div className="record-search-label">{this.props.langText.Body.CustomerName}</div>
                    </Col>
                    <Col sm={12} md={4} lg={2}>
                        <FormControl
                            onChange = {
                                e => this.onChange(e, "customer_name")
                            }
                            value = {this.getFilterData("customer_name")}
                        />
                    </Col>
                    <Col sm={4} md={2} lg={1}>
                        <div className="record-search-label">{this.props.langText.Body.DestTelNumber}</div>
                    </Col>
                    <Col sm={12} md={4} lg={2}>
                        <FormControl
                            onChange = {
                                e => this.onChange(e, "dest_tel_number")
                            }
                            value = {this.getFilterData("dest_tel_number")}
                        />
                    </Col>
                    {/* Aspire オプション OFF 時: 発着信を 2行目末尾に同居 (従来通り) */}
                    {!(this.props.userInfo.options && this.props.userInfo.options.aspire) && inOutTypeFilter}
                </Row>
                {/* Aspire オプション ON 時: 内線番号を含めると 2行目が 5項目になり発着信が自動 wrap して上の行と間隔が詰まるため、独立した行に切り出して margin を揃える */}
                {!!(this.props.userInfo.options && this.props.userInfo.options.aspire) && (
                    <Row className="record-search-row">
                        {inOutTypeFilter}
                    </Row>
                )}
                {/* 3行目: ユーザーID、検索ボタン、件数、検索結果への操作（VoC 分析・CSV） */}
                <Row className="record-search-row">
                    <Col sm={4} md={2} lg={1}
                         hidden={!this.props.userInfo.options.RecAceApp || !this.getLevelGreaterEqual(GlobalConst.LEVEL_OBJECT.company)}
                    >
                        <div className="record-search-label">{this.props.langText.Body.UserId}</div>
                    </Col>
                    <Col sm={12} md={4} lg={2}
                         hidden={!this.props.userInfo.options.RecAceApp || !this.getLevelGreaterEqual(GlobalConst.LEVEL_OBJECT.company)}
                    >
                        <FormControl
                            onChange = {
                                e => this.onChange(e, "user_id")
                            }
                            value = {this.getFilterData("user_id")}
                        />
                    </Col>
                    <Col
                        xs={12}
                        sm={12}
                        md={6}
                        lg={this.props.userInfo.options.RecAceApp && this.getLevelGreaterEqual(GlobalConst.LEVEL_OBJECT.company) ? 9 : 12}
                        className="d-flex align-items-center"
                    >
                        <div className="d-flex align-items-center">
                            <Button
                                id="record-search"
                                className="searchBtn"
                                disabled={!this.state.search_flag}
                                onClick={e => {
                                    this.onSearch(e);
                                    this.getAudio2TextUsageMonth();
                                }}>
                                {this.props.langText.Body.Search}
                            </Button>
                        </div>
                        <div className="record-message-count ms-4">
                            {!this.state.filtered.some(row => row.id === "answer_datetime") ? "最新" : null}
                            {this.state.count ? this.numberWithCommas(this.state.count) : 0}
                            {this.props.langText.Body.Count}
                        </div>
                        <div className="ms-auto d-flex align-items-center gap-2">
                            {
                                this.props.userInfo
                                && this.props.userInfo.permission_data
                                && this.props.userInfo.permission_data.VocHistory
                                && this.props.userInfo.permission_data.VocHistory.create
                                ? (
                                    <Button
                                        id="record-voc-analysis"
                                        className="searchBtn"
                                        onClick={this.openVocAnalysisModal}
                                    >
                                        {this.props.langText.Body.VocAnalysis}
                                    </Button>
                                ) : null
                            }
                            {
                                this.props.userInfo
                                && this.props.userInfo.permission_data
                                && this.props.userInfo.permission_data.Record
                                && this.props.userInfo.permission_data.Record.download
                                ? (
                                    <Button
                                        id="record-csv-download"
                                        className="searchBtn"
                                        disabled={!this.state.data || this.state.data.length === 0 || this.state.csvDownloading}
                                        onClick={this.downloadSearchResultsCSV}
                                    >
                                        {this.state.csvDownloading
                                            ? this.props.langText.Body.Downloading
                                            : this.props.langText.Body.CsvDownload}
                                    </Button>
                                ) : null
                            }
                        </div>
                    </Col>
                </Row>
                </div>
                <Row>
                    <>
                        {
                            this.state.blocking &&
                            <div className="asc-block-ui-record">
                                <div className="asc-block-icon-box">
                                    <ReactLoading className="asc-block-icon" type="spinningBubbles" color="#b8b8b8" />
                                    <label className="asc-block-label">{this.props.langText.Body.Wait}</label>
                                </div>
                            </div>
                        }
                        <Col xs={12} md={12} className = " margin-top-05">
                            <div ref={this.tableAreaRef}>
                            <CommonTable
                                showPageSize={true}
                                showCheckbox={false}
                                showPagination={true}
                                manual = {true}
                                state = {this.state}
                                tableHeight={this.state.tableHeight || this.props.tableHeight}
                                tbodyHeight={this.state.tableHeight || this.props.tableHeight}
                                tableBottomHeight={80}
                                columns={this.state.columns}
                                filtered={this.state.filtered}
                                sorted={this.state.sorted}
                                pageCount = {this.state.pageCount}
                                propsPageIndex = {this.state.pageIndex? this.state.pageIndex: 0}
                                data={this.state.data}
                                loading={this.state.loading}
                                onFetchData={this.fetchData}
                                langText = {this.props.langText.Table}
                            />
                            </div>
                        </Col>
                    </>
                </Row>
                {/*モーダル表示分岐*/}
                {this.getModalBranch()}
            </div>
        );
    }
}


